const documents = {
    cells: {
      "title": "Excelセル参照",
      "notice": "読み取り専用のセル値表示です。書式・図は再現しません。クリックとShift＋クリックで最大400セルを選択し、選択範囲だけを質問できます。結合セルは範囲全体を選択してください。",
      "sheet": "シート",
      "ask": "この範囲について質問",
      "loading": "セルを読み込み中…",
      "stale": "資料が改版されています。この引用の原本と一致しないため表示を停止しました。",
      "failed": "セル参照を取得できません。",
      "grid": "Excelセル",
      "hidden": "非表示",
      "noCache": "数式の保存値なし",
      "merges": "結合範囲（値は左上セル）",
      "previousRows": "前の100行",
      "nextRows": "次の100行",
      "previousColumns": "前の20列",
      "nextColumns": "次の20列",
      "toggle": "セル参照／簡易プレビューを切替",
      "scope": "選択範囲のみを参照",
      "selectionFailed": "Excelの参照を確認できません。資料の版・権限・選択範囲を確認し、再選択してください。"
},
    columns: {
      title: 'ドキュメント',
      category: 'カテゴリー',
      size: 'サイズ',
      updatedAt: '更新日',
    },
    countLabel: '{{count}} 件のドキュメント',
    title: 'ドキュメント',
    uploadDocument: 'ドキュメントをアップロード',
    documentList: 'ドキュメント一覧',
    gridView: 'グリッド表示',
    listView: 'リスト表示',
    searchPlaceholder: 'ドキュメントを検索...',
    filters: 'フィルター',
    applyFilters: 'フィルターを適用',
    sortBy: '並び替え',
    sortOptions: {
      date: '日付',
      name: '名前',
      size: 'サイズ',
      category: 'カテゴリー',
    },
    dateInput: {
      startLabel: '開始日',
      endLabel: '終了日',
      format: 'YYYY-MM-DD',
      invalid: '日付は YYYY-MM-DD 形式で入力してください',
      reversed: '開始日は終了日と同じか、それより前の日付にしてください',
    },
    sortOrder: {
      asc: '昇順',
      desc: '降順',
    },
    noDocumentsFound: 'ドキュメントが見つかりません',
    tryAdjustingFilters: 'フィルターや検索クエリを調整してみてください',
    duplicateUpload: '同じファイルが既にアップロードされています',
    generalCategory: '一般',
    deepAnalyzed: '深く分析済み',
    loadMore: 'さらに読み込む',
    resultsCount: '{{shown}} / {{total}} 件のドキュメント',
    shareDocument: 'ドキュメントを共有',
    shareComingSoon: '共有機能は現在開発中です。',
    deleteTitle: 'ドキュメントを削除',
    deleteConfirm: '「{{name}}」を削除します。この操作は取り消せません。削除してもよろしいですか？',
    deleteSuccess: 'ドキュメントを削除しました',
    deleteFailed: 'ドキュメントの削除に失敗しました',
    downloadFailed: 'ファイルのダウンロードに失敗しました',
    downloadNotFound: 'ファイルが見つかりません',
    downloadTimedOut: 'ダウンロードがタイムアウトしました。通信環境を確認してもう一度お試しください',
    downloadInProgress: 'このファイルはダウンロード中です',
    deletePermissionHint: '削除は管理者、アップロードした本人、または対象ドキュメントの削除権限を持つ利用者が実行できます。',

    // Document fields
    document: 'ドキュメント',
    category: 'カテゴリー',
    uploadedBy: 'アップロードユーザ',
    size: 'サイズ',
    modified: '更新日時',
    version: 'バージョン',

    // Filters
    filterBy: '絞り込み',
    categories: 'カテゴリー',
    tags: 'タグ',
    fileTypes: 'ファイルタイプ',
    dateRange: '日付範囲',
    startDate: '開始日',
    endDate: '終了日',
    activeFilters: '{{count}}個のフィルター',
    activeFilter: '{{count}}個のフィルター',

    // Document Detail Page
    details: '詳細',
    versionHistory: 'バージョン履歴',
    permissions: '権限',
    metadata: 'メタデータ',
    department: '部署',
    classification: '分類',
    retentionPeriod: '保存期間',
    lastModified: '最終更新',
    years: '年',
    actions: 'アクション',
    preview: 'プレビュー',
    loadingPreview: 'プレビューを読み込み中...',
    uploadNewVersion: '新しいバージョンをアップロード',
    failedToLoad: 'ドキュメントの読み込みに失敗しました',
    documentNotFound: 'ドキュメントが見つかりません',
    returnToDocuments: 'ドキュメント一覧に戻る',
    analysisHistory: '分析履歴',
    analysisHistoryView: {
      emptyTitle: 'このドキュメントにはまだ深い分析履歴がありません。',
      emptyDescription: 'チャットで「ドキュメントを選択し、深い分析をお願いします」と依頼すると、詳細な技術分析が記録されます。',
      title: '分析履歴 ({{count}}件)',
      type: {
        deepTechnicalAnalysis: '深い技術分析',
        summary: '要約',
        extraction: 'データ抽出',
      },
      createdBy: '作成者: {{name}}',
      showContent: '分析内容を表示',
    },
    detailTabsAria: 'ドキュメント詳細タブ',
    previewUnavailableForType: '{{type}}のプレビューは利用できません',
    spreadsheetPreviewFrameTitle: 'Excelドキュメントの読み取り専用プレビュー',
    previewLoadFailed: 'プレビューの読み込みに失敗しました',
    convertingSlidePreview: 'スライドを変換しています...',
    preparingSlidePreview: 'スライドのプレビューを準備しています...',
    slidePreviewFailed: 'スライドのプレビューを準備できませんでした',
    slidePreviewFailedReason: {
      unconvertible: 'このプレゼンテーションはプレビューに変換できませんでした',
      timeout: 'プレゼンテーションの変換に時間がかかりすぎました',
      unavailable: 'プレビュー変換は現在利用できません',
      too_many_slides: 'スライド数が多すぎるためプレビューできません',
    },
    slideNumber: 'スライド{{number}}',
    zoomIn: 'ズームイン',
    zoomOut: 'ズームアウト',
    openFullImage: '拡大画像を開く',
    previewLoadFailedWithStatus: 'プレビューの読み込みに失敗しました: {{status}}',
    previewLoadFailedWithStatusText: 'プレビューの読み込みに失敗しました: {{status}} {{statusText}}',
    fileTypeFallback: 'このファイル形式',
    fileName: 'ファイル名',
    fileType: 'ファイル種別',
    fileSize: 'ファイルサイズ',
    status: 'ステータス',
    createdAt: '作成日',
    reExtractMetadata: 'メタデータを再抽出',
    reExtractMetadataDescription: 'LLMを使用してドキュメントからメタデータを再生成します。更新したい項目を選択してください。',
    regenerateTitle: 'タイトルを再生成',
    regenerateSummary: 'サマリーを再生成',
    regenerateTags: 'タグを再生成',
    tagTooLong: 'タグは{{max}}文字以内で入力してください',
    uploadMimeNotAllowed: '{{name}}: サポートされていないファイル形式です（{{type}}）',
    uploadMimeUnknown: '{{name}}: ファイル形式を判別できませんでした。保存し直してからお試しください',
    reExtractingMetadata: 'メタデータ再抽出中...',
    selectAtLeastOneMetadataField: '少なくとも1つの項目を選択してください',
    metadataReExtracted: 'メタデータを再抽出しました（更新項目: {{count}}件）',
    metadataReExtractFailed: 'メタデータの再抽出に失敗しました',
    reExtractConfirmAction: '再抽出する',
    reExtractMetadataConfirmTitle: 'メタデータの再抽出',
    reExtractMetadataConfirmMessage:
      'AIが生成した内容で、タイトル・要約・タグを上書きします。手動で編集した内容は失われ、この操作は取り消せません。再抽出してもよろしいですか？',
    extractedImagesTitle: '抽出画像・図面',
    itemCount: '({{count}}個)',
    imageAnalysisComplete: '画像分析が完了しました',
    imageAnalysisFailed: '画像分析に失敗しました',
    imagesAnalyzed: '{{count}}個の画像を分析しました',
    imagesReanalyzed: '{{count}}個の画像を再分析しました',
    imagesExtracted: '{{count}}個の画像を抽出しました',
    blueprintImagesExtracted: '{{count}}個の図面画像を抽出しました',
    imageReExtractFailed: '画像の再抽出に失敗しました。',
    blueprintReExtractFailed: '図面画像の再抽出に失敗しました。',
    aiAnalyzing: 'AI分析中...',
    analyzeAllImages: '全画像をAI分析',
    forceReanalyze: '既存の分析結果も再分析する',
    extracting: '抽出中...',
    reExtractImages: '画像を再抽出',
    reExtractAsBlueprint: '図面として再抽出',
    reExtractImagesConfirmTitle: '画像の再抽出',
    reExtractBlueprintConfirmTitle: '図面として再抽出',
    reExtractImagesConfirmMessage:
      '抽出済みの画像とそのAI解析結果をすべて削除してから、画像を抽出し直します。この操作は取り消せません。再抽出してもよろしいですか？',
    analyzeAllImagesConfirmTitle: 'すべての画像を再解析',
    analyzeAllImagesConfirmMessage:
      '「再解析を強制」が有効です。すべての画像の既存のAI解析結果を上書きします。この操作は取り消せません。実行してもよろしいですか？',
    analyzeAllImagesConfirmAction: '再解析する',
    imagesSelected: '{{count}}個選択中',
    selectTwoImages: '画像を2つ選択してください',
    selectAtLeastTwoImages: '2つ以上の画像を選択してください',
    sequenceAnalysisMaxImages: 'シーケンス分析は最大{{count}}個の画像まで対応しています',
    extractedImageAlt: 'Page {{page}}, Image {{index}}',
    imageLoadFailed: '画像を読み込めません',
    imageFileNotFound: 'ファイルが見つかりません',
    imagePageCaption: 'Page {{page}} - Image {{index}}',
    aiAnalysisResult: 'AI分析結果',
    analyzing: '分析中...',
    reanalyze: '再分析',
    reanalyzeImageConfirmTitle: 'AI解析をやり直す',
    reanalyzeImageConfirmMessage:
      '既存のAI解析結果を上書きします。以前の内容は復元できません。やり直してもよろしいですか？',
    reanalyzeImageConfirmAction: 'やり直す',
    aiAnalysis: 'AI分析',
    noExtractedImages: 'このドキュメントから抽出された画像はありません',
    documentPermissions: 'ドキュメント権限',
    versionHistoryFetchFailed: 'バージョン履歴の取得に失敗しました',
    versionHistoryLoadFailed: 'バージョン履歴の読み込みに失敗しました',
    noDescription: '説明なし',
    noVersionHistory: 'バージョン履歴がありません',
    versionWithNumber: 'バージョン {{version}}',
    versionWithCurrent: 'バージョン {{version}}（現在）',
    currentVersion: '現在',
    deepAnalysisCompleted: '深い分析実施済み',
    deepTechnicalAnalysis: '深い技術分析',
    createdBy: '作成者: {{name}}',
    compare: '比較',
    restore: '復元',
    compareWithCurrent: '現在のバージョンと比較',
    restoreThisVersion: 'このバージョンを復元',
    compareVersions: 'バージョンを比較',
    versus: 'vs',
    versionComparisonComingSoon: 'バージョン比較ビューはここに実装予定です',
    pdfLoadFailed: 'PDFドキュメントの読み込みに失敗しました',
    pdfSearchTooltip: '検索（N/Pキーで結果を移動）',
    toggleResultsList: '結果リストを切り替え',
    searchInDocument: 'ドキュメント内を検索...',
    pageResultPreview: '{{page}}ページ: {{text}}...',
    previousResultShortcut: '前へ (P)',
    nextResultShortcut: '次へ (N)',
    imageComparison: {
      title: '画像比較・連携分析',
      type: '比較タイプ',
      compareTwo: '2つを比較',
      sequenceAnalysis: 'シーケンス分析 ({{count}}個)',
      selectImagesHint: '画像を選択して比較・連携分析を開始',
      compareResultTitle: '画像比較分析結果',
      sequenceResultTitle: '画像シーケンス分析結果',
      aiAnalyzingPleaseWait: 'AI分析中...しばらくお待ちください',
      typeWithValue: '比較タイプ: {{type}}',
      resultLoadFailed: '分析結果の取得に失敗しました',
      types: {
        changes: '変更点',
        evolution: '設計進化',
        differences: '違い',
      },
    },
  };

export default documents;
